import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';
import { LiqPayCredentials, UpdateLiqPayCredentialsBody } from '../../resources/types/liqPayTypes';

export const liqPayApi = createApi({
  reducerPath: 'liqPayApi',
  baseQuery,
  tagTypes: ['LiqPayCredentials'],
  endpoints: builder => ({
    // Масив, бо при ротації в місті кілька ключів
    getLiqPayCredentials: builder.query<LiqPayCredentials[], string>({
      query: city => ({ url: '/liqpayconfigs/credentials', params: { city } }),
      transformResponse: (response: { data: LiqPayCredentials[] }) => response.data,
      providesTags: (result, error, city) => [{ type: 'LiqPayCredentials', id: city }]
    }),

    updateLiqPayCredentials: builder.mutation<LiqPayCredentials, UpdateLiqPayCredentialsBody>({
      query: body => ({ url: '/liqpayconfigs/credentials', method: 'PUT', body }),
      transformResponse: (response: { data: LiqPayCredentials }) => response.data,
      invalidatesTags: (result, error, { city }) => [{ type: 'LiqPayCredentials', id: city }]
    })
  })
});

export const { useGetLiqPayCredentialsQuery, useUpdateLiqPayCredentialsMutation } = liqPayApi;
